module.exports = __webpack_public_path__ + "img/anatomy-for-sculptors-male-and-female-skull-differences-form-of-the-hex-and-neck-x1000-optimized.580e40e2.jpg";